export class Errors {
  errors: {[key: string]: string} = {};
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/shared/models/errors.model.ts